import self from "../img/self.png"
import mock8 from "../img/mock8.png"
import mock10 from "../img/mock10.png"
import mock11 from "../img/mock11.png"
import mock15 from "../img/mock15.png"
import mock17 from "../img/mock17.png"
import mock18 from "../img/mock18.png"
import mock20 from "../img/mock20.png"
import mock21 from "../img/mock21.png"
import mock22 from "../img/mock22.png"
/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

// export let colors = ["rgb(0,255,144)", "rgb(166,104,255)"];
// Black and White
// export let colors = ["rgb(0, 0, 0)", "rgb(255, 255, 255)"];

// // Gold and White
// export let colors = ["rgb(255, 215, 0)", "rgb(255, 255, 255)"];

// // Teal and White
// export let colors = ["rgb(0, 128, 128)", "rgb(255, 255, 255)"];

// // Gold and Black
// export let colors = ["rgb(255, 215, 0)", "rgb(0, 0, 0)"];

// // Teal and Black
// export let colors = ["rgb(0, 128, 128)", "rgb(0, 0, 0)"];

// // Silver and White
// export let colors = ["rgb(192, 192, 192)", "rgb(255, 255, 255)"];

// // Gray and White
// export let colors = ["rgb(128, 128, 128)", "rgb(255, 255, 255)"];

// // Rose and White
// export let colors = ["rgb(255, 255, 255)", "rgb(255, 102, 184)"];

// // Navy Blue and White
// export let colors = ["rgb(0, 0, 128)", "rgb(255, 255, 255)"];

// // Olive and White
// export let colors = ["rgb(128, 128, 0)", "rgb(255, 255, 255)"];

// // Orange and White
// export let colors = ["rgb(255, 165, 0)", "rgb(255, 255, 255)"];

// // Purple and Black
// export let colors = ["rgb(128, 0, 128)", "rgb(0, 0, 0)"];

// // Cyan and Black
// export let colors = ["rgb(0, 255, 255)", "rgb(0, 0, 0)"]; 

// // Lime Green and White
// export let colors = ["rgb(50, 205, 50)", "rgb(255, 255, 255)"];

// // Magenta and Black
// export let colors = ["rgb(255, 0, 255)", "rgb(0, 0, 0)"];

// // Coral and White
// export let colors = ["rgb(255, 127, 80)", "rgb(255, 255, 255)"];

// // Turquoise and Black
// export let colors = ["rgb(64, 224, 208)", "rgb(0, 0, 0)"];

// // Crimson and White
// export let colors = ["rgb(220, 20, 60)", "rgb(255, 255, 255)"]; 

// // Forest Green and White
// export let colors = ["rgb(34, 139, 34)", "rgb(255, 255, 255)"];

// // Pink and Black
export let colors = ["rgb(65, 105, 225)", "rgb(150, 50, 50)"];

// // Royal Blue and White
// export let colors = ["rgb(65, 105, 225)", "rgb(255, 255, 255)"];

// // Bronze and White
// export let colors = ["rgb(205, 127, 50)", "rgb(255, 255, 255)"];

// // Indigo and Black
// export let colors = ["rgb(75, 0, 130)", "rgb(0, 0, 0)"];

// // Light Blue and White
// export let colors = ["rgb(273, 216, 230)", "rgb(255, 255, 255)"];

// // Mint Green and Black
// export let colors = ["rgb(152, 255, 152)", "rgb(0, 0, 0)"];




/* 
This variable will change the layout of the website from multipage to single, scrollable page
*/
export let singlePage = false

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

// Dynamic color function: returns [dark, light] for light/dark mode
export function getColors(darkMode) {
    return darkMode
        ? ["rgb(255,255,255)", "rgb(30,30,30)"] // light mode: white to dark gray
        : ["rgb(30,30,30)", "rgb(255,255,255)"]; // dark mode: dark gray to white
}

export const info = {
    firstName: "Vansh",
    lastName: "Sharma",
    initials: "vs.", // the example uses first and last, but feel free to use three or more if you like.
    position: "a Web Developer",
    selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
    gradient: (typeof window !== 'undefined' && window.localStorage && JSON.parse(window.localStorage.getItem('darkMode')))
        ? `-webkit-linear-gradient(135deg, ${getColors(true)[0]}, ${getColors(true)[1]})`
        : `-webkit-linear-gradient(135deg, ${getColors(false)[0]}, ${getColors(false)[1]})`,
    // don't change this either
    baseColor: (typeof window !== 'undefined' && window.localStorage && JSON.parse(window.localStorage.getItem('darkMode')))
        ? getColors(true)[0]
        : getColors(false)[0],
    miniBio: [ 
        {
            emoji: '☕',
            text: 'fueled by Chai'
        },
        {
            emoji: '🌎',
            text: 'based in India'
        },
        {
            emoji: "💼",
            text: "Web Developer"
        },
        {
            emoji: "📧",
            text: "vansh.txt@gmail.com"
        }
    ],
    socials: [
        {
            link: "https://www.instagram.com/vanishedddddddd/",
            icon: 'fa fa-instagram',
            label: 'instagram'
        },
        {
            link: "https://github.com/VanshSharma0",
            icon: 'fa fa-github',
            label: 'github'
        },
        {
            link: "https://www.linkedin.com/in/vansh-sharma0/",
            icon: "fa fa-linkedin",
            label: 'linkedin'
        }
// Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
// Just change the links so that they lead to your social profiles.

    ],
    bio: "Hello! I'm Vansh. I am a FullStack Developer actively seeking web development opportunities. With expertise in JavaScript, React, Express, Node js, Mongo DB, Java, SQL. I’m Eager to contribute to both team and individual projects.",
    skills:
        {
            proficientWith: ['Java', 'C', 'JavaScript', 'React', 'SQL', "Node js", "Express js", "TypeScript"],
            exposedTo: ['Linux', 'MySQL', 'Git', 'Mongo DB', 'Data Structures & Algorithms', 'Figma', 'Photoshop']
        }
    ,
    hobbies: [
        {
            label: 'Chess',
            emoji: '🐴'
        },
        {
            label: 'movies',
            emoji: '🎥'
        },
        {
            label: 'cooking',
            emoji: '🌶'
        }
    ],
    portfolio: [ // This is where your portfolio projects will be detailed
        {
            title: "Eventiate – B2B SaaS Platform",
            live: "https://eventiate.ai",
            image: mock22,   
        },
        {
            title: "Crypto Whale",
            live: "https://cryptocurrency-whale.vercel.app/",
            image: mock21,   
        },
        {
            title: "Indus Valley Mukhteshwar",
            live: "https://www.indusvalleymukteshwar.com",
            image: mock20,
            source: "https://github.com/VanshSharma0/Indus"
        },
        {
            title: "Murti Jewellers Store",
            live: "https://murtijewels.shop",
            image: mock15
        },
        {
            title: "2048",
            live: "https://2048inreact.vercel.app/",
            image: mock17
        },
        {
            title: "TechBlob - Blog Application",
            live: "https://megablogapp.vercel.app/",
            source: "https://github.com/VanshSharma0/BlogApplication",
            image: mock8
        },
        {
            title: "FastBills - Invoice Generator",
            live: "https://fastbills.netlify.app/",
            source: "https://github.com/VanshSharma0/Fastbills",
            image: mock11
        }
    ]
}